import LABEL from "./label";

const DOCUMENT_LINES_COLUMNS = [
  { key: "index", label: "#", width: 56 },
  { key: "details", label: LABEL.LINE_DETAILS.description, width: 360 },
  { key: "expenseGroup", label: LABEL.EXPENSE_GROUP_DROPDOWN.label, width: 220 },
  { key: "article", label: LABEL.LINE_DETAILS.article, width: 260 },
  { key: "unit", label: LABEL.LINE_DETAILS.measureUnit, width: 120 },
  { key: "quantity", label: LABEL.LINE_DETAILS.quantity, width: 140 },
  { key: "unitPriceWithoutVat", label: LABEL.LINE_DETAILS.unitPriceWithoutVat, width: 180 },
  { key: "vatValue", label: LABEL.LINE_DETAILS.vatPercentage, width: 140 },
  { key: "costCenter", label: LABEL.COST_CENTER_DROPDOWN?.label || "Cost Center", width: 220 },
  { key: "objectNumber", label: LABEL.PROJECTS_DROPDOWN?.label || "Project", width: 220 },
  { key: "invoicePeriodStartDate", label: LABEL.LINE_DETAILS.invoicePeriodStartDate, width: 180 },
  { key: "invoicePeriodEndDate", label: LABEL.LINE_DETAILS.invoicePeriodEndDate, width: 180 },
];

export default DOCUMENT_LINES_COLUMNS;